import {FC} from "react";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {
    selectEventsPopupVisible, setEventsPopupVisible,
} from "../../../features/AppStateSlice";
import {EventsDialog} from "../events/EventsDialog";

const EventsPopup: FC = () => {
    const dispatch = useAppDispatch();
    const isVisible = useAppSelector(selectEventsPopupVisible);

    return (
        <EventsDialog zIndex={1100} show={isVisible}
                         onClose={() => dispatch(setEventsPopupVisible(false))} />
    );
}

export default EventsPopup;
